// import React from "react";
// import "./Operations.css";
// import Accordion from "react-bootstrap/Accordion";
// import { formatBoldText } from "../../../../../services/commonService";
// import WorldHeatmapGeneric from "../../../../HtmlElements/WorldHeatmapGeneric";

// function ManufacturingAndTechnologyInfrastructure({
//   manufacturingAndTechnologyInfrastructure = [],
// }) {
//   const facilityProfiles =
//     manufacturingAndTechnologyInfrastructure?.[0]?.response
//       ?.operations_footprint?.plants || [];

//   const dummyData = [
//     {
//       site_name: "Delhi Plant",
//       location: {
//         country: "India",
//         city: "New Delhi",
//         address: "Connaught Place",
//         latitude: 28.6139,
//         longitude: 77.209,
//       },
//     },
//     {
//       site_name: "Mumbai Warehouse",
//       location: {
//         country: "India",
//         city: "Mumbai",
//         address: "Andheri" /* no lat/lon to test approx */,
//         latitude: 28.9,
//         longitude: 78.209,
//       },
//     },
//     {
//       site_name: "New York Facility",
//       location: {
//         country: "United States",
//         city: "New York",
//         address: "Manhattan",
//         latitude: 40.7128,
//         longitude: -74.006,
//       },
//     },
//     {
//       site_name: "San Francisco Office",
//       location: {
//         country: "United States",
//         city: "San Francisco",
//         address: "Market St" /* no lat/lon to test approx */,
//       },
//     },
//   ];

//   return (
//     <div className="product_new_wrapper">
//       <div className="table_head_block">
//         <div className="table_subblock_left">
//           <h5 className="table_head">Global Operations Network</h5>
//         </div>
//       </div>

//       <div className="mb-4">
//         <div className="custom_card_heatmap">
//           <WorldHeatmapGeneric
//             facilityProfiles={facilityProfiles}
//             // facilityProfiles={dummyData}
//             mapId="plantsMap"
//           />
//         </div>
//       </div>

//       {facilityProfiles.map((facility, idx) => (
//         <>
//           <div className="water_adh_block" key={idx}>
//             <div className="head_block">
//               <div className="head_subblock">
//                 <div className="head_icon_text">
//                   <h5 className="head_text_chip">
//                     {facility?.site_name || "—"}
//                   </h5>
//                 </div>
//               </div>

//               <div className="head_high_block">
//                 <div className="label_with_text">
//                   <div className="chips-row" aria-label="overview chips">
//                     <div className="chip">
//                       <span className="chip-icon" aria-hidden="true">
//                         <svg
//                           width="12"
//                           height="12"
//                           viewBox="0 0 24 24"
//                           fill="none"
//                           stroke="currentColor"
//                           strokeWidth="2"
//                         >
//                           <path d="M12 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"></path>
//                           <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 1 1 18 0z"></path>
//                         </svg>
//                       </span>
//                       <span className="chip-label">
//                         {facility?.location?.country || "—"}
//                         {", "}
//                         {/* {facility?.location?.state_province || "—"}
//                       {", "} */}
//                         {facility?.location?.city || "—"}
//                         {", "}
//                         {facility?.location?.address || "—"}
//                       </span>
//                     </div>

//                     {facility?.timeline?.length > 0 && (
//                       <div className="chip">
//                         <span className="chip-icon" aria-hidden="true">
//                           <svg
//                             width="12"
//                             height="12"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             stroke="currentColor"
//                             strokeWidth="2"
//                           >
//                             <rect
//                               x="3"
//                               y="4"
//                               width="18"
//                               height="18"
//                               rx="2"
//                             ></rect>
//                             <path d="M16 2v4"></path>
//                             <path d="M8 2v4"></path>
//                           </svg>
//                         </span>
//                         <span className="chip-label">
//                           {facility?.timeline || "—"}
//                         </span>
//                       </div>
//                     )}

//                     {/* Facility size */}
//                     {facility?.facility_size_sqft && (
//                       <div className="chip">
//                         <span className="chip-icon" aria-hidden="true">
//                           <svg
//                             width="12"
//                             height="12"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             stroke="currentColor"
//                             strokeWidth="2"
//                           >
//                             <path d="M3 7h18M3 12h18M3 17h18"></path>
//                           </svg>
//                         </span>
//                         <span className="chip-label">
//                           {facility?.facility_size_sqft || "—"}
//                         </span>
//                       </div>
//                     )}

//                     {/* Utilization */}
//                     {facility?.utilization_rate && (
//                       <div className="chip">
//                         <span className="chip-icon" aria-hidden="true">
//                           <svg
//                             width="12"
//                             height="12"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             stroke="currentColor"
//                             strokeWidth="2"
//                           >
//                             <circle cx="12" cy="12" r="8"></circle>
//                             <path d="M12 8v4l2 2"></path>
//                           </svg>
//                         </span>
//                         <span className="chip-label">
//                           {facility?.utilization_rate || "—"}
//                         </span>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="table_block_chip">
//               <div className="table-responsive">
//                 <table className="custom-resizable-table">
//                   <thead>
//                     <tr className="custom-resizable-table-header">
//                       <th>
//                         <div className="custom-resizable-table-th-content">
//                           Products & Technology
//                         </div>
//                       </th>
//                       {/* <th>
//                       <div className="custom-resizable-table-th-content">
//                         Technology
//                       </div>
//                     </th> */}
//                       <th className="custom-resizable-table-th-content">
//                         <div className="custom-resizable-table-th-content">
//                           Capabilities
//                         </div>
//                       </th>

//                       <th>
//                         <div className="custom-resizable-table-th-content">
//                           Specialization
//                         </div>
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     <tr className="gtr-row" style={{ backgroundColor: "#fff" }}>
//                       <td className="gtr-cell">
//                         <p>
//                           {formatBoldText(
//                             facility?.products_and_technologies?.join(", ")
//                           ) || "—"}
//                         </p>
//                       </td>

//                       {/* <td className="gtr-cell">
//                       <p>
//                         {formatBoldText(
//                           facility?.technology_equipment?.value
//                         ) || "—"}
//                       </p>
//                     </td> */}

//                       <td className="gtr-cell">
//                         <p>
//                           {formatBoldText(facility?.capabilities?.join(", ")) ||
//                             "—"}
//                         </p>
//                       </td>

//                       <td className="gtr-cell">
//                         <p>
//                           {formatBoldText(
//                             facility?.specializations?.join(", ")
//                           ) || "—"}
//                         </p>
//                       </td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>
//         </>
//       ))}
//     </div>
//   );
// }

// export default ManufacturingAndTechnologyInfrastructure;

import React, { useEffect } from "react";
import "./Operations.css";
import { formatBoldText } from "../../../../../services/commonService";
import WorldHeatmapGeneric from "../../../../HtmlElements/WorldHeatmapGeneric";
import CollapsibleCell from "../../../../HtmlElements/CollapsibleCell";
import InfoTooltipIcon from "../../../../HtmlElements/InfoTooltipIcon";

function ManufacturingAndTechnologyInfrastructure({
  manufacturingAndTechnologyInfrastructure = [],
  plantCount,
  setPlantCount,
}) {
  // Extract the response object
  const responseObj =
    manufacturingAndTechnologyInfrastructure?.[0]?.response || {};

  // helper to detect if a field is an object that can be used as tooltip payload
  const hasTooltipPayload = (field) =>
    field != null && typeof field === "object" && field.value != null;

  // Check if new nested format exists
  let facilityProfiles = [];

  if (responseObj.facilities?.length) {
    // New data format
    facilityProfiles = responseObj.facilities.map((f) => ({
      site_name: f.facility_name,
      location: {
        country: f.location?.split(",")?.[2]?.trim() || "",
        city: f.location?.split(",")?.[0]?.trim() || "",
        address: f.location?.split(",")?.[1]?.trim() || "",
        latitude: f.latitude?.value || f.latitude || null,
        longitude: f.longitude?.value || f.longitude || null,
      },
      facility_size_sqft: f.facility_size_sqft,
      utilization_rate: f.utilization_rate,
      products_and_technologies: [
        f.products_and_applications?.value,
        f.technology_equipment?.value,
        f.digital_systems?.value,
      ].filter(Boolean),
      capabilities: [
        f.lean_processes?.value,
        f.competitive_advantage?.value,
      ].filter(Boolean),
      specializations: [f.specialization_focus?.value].filter(Boolean),
    }));

    setPlantCount(facilityProfiles?.length);
  } else if (responseObj.operations_footprint?.plants?.length) {
    // Old data format
    facilityProfiles = responseObj.operations_footprint.plants;
    setPlantCount(facilityProfiles?.length);
  }

  // useEffect(() => {
  //   console.log("FACILITIES: " + JSON.stringify(facilityProfiles));
  // }, [facilityProfiles]);

  if (facilityProfiles?.length === 0) {
    return <></>;
  }

  const isInvalidValue = (value) => {
    if (!value) return true;

    if (typeof value === "string") {
      const v = value.toLowerCase().trim();
      return v === "unknown" || v === "baseline";
    }

    return false;
  };

  return (
    <div className="product_new_wrapper">
      <div className="table_head_block">
        <div className="table_subblock_left">
          <h5 className="table_head">Global Operations Network</h5>
        </div>
      </div>

      <div className="mb-4">
        <div className="custom_card_heatmap">
          <WorldHeatmapGeneric
            facilityProfiles={facilityProfiles}
            mapId="plantsMap"
          />
        </div>
      </div>

      {facilityProfiles.map((facility, idx) => (
        <div className="water_adh_block" key={idx}>
          <div className="head_block">
            <div className="head_subblock">
              <div className="head_icon_text">
                <h5 className="head_text_chip">{facility?.site_name || "—"}</h5>
              </div>
            </div>

            <div className="head_high_block">
              <div className="label_with_text">
                <div className="chips-row" aria-label="overview chips">
                  {/* {facility?.location?.country?.length > 0 &&
                    facility?.location?.city?.length > 0 &&
                    facility?.location?.address?.length > 0 &&
                    !facility?.location?.country
                      .toLowerCase()
                      .includes("unknown") && ( */}
                  {facility?.location &&
                    !isInvalidValue(facility.location.country) &&
                    !isInvalidValue(facility.location.city) &&
                    !isInvalidValue(facility.location.address) && (
                      <div className="chip">
                        <span className="chip-icon" aria-hidden="true">
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <path d="M12 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"></path>
                            <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 1 1 18 0z"></path>
                          </svg>
                        </span>
                        <span className="chip-label">
                          {facility?.location?.country},{" "}
                          {facility?.location?.city},{" "}
                          {facility?.location?.address}
                        </span>
                      </div>
                    )}

                  {facility?.facility_size_sqft &&
                    !isInvalidValue(facility?.facility_size_sqft) && (
                      <div className="chip">
                        <span className="chip-icon" aria-hidden="true">
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <path d="M3 7h18M3 12h18M3 17h18"></path>
                          </svg>
                        </span>
                        <span className="chip-label">
                          {facility.facility_size_sqft}
                        </span>
                      </div>
                    )}

                  {facility?.utilization_rate &&
                    !isInvalidValue(facility?.utilization_rate) && (
                      <div className="chip">
                        <span className="chip-icon" aria-hidden="true">
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <circle cx="12" cy="12" r="8"></circle>
                            <path d="M12 8v4l2 2"></path>
                          </svg>
                        </span>
                        <span className="chip-label">
                          {facility.utilization_rate}
                        </span>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>

          <div className="table_block_chip mt-2">
            <div className="table-responsive">
              <table className="custom-resizable-table">
                <thead>
                  <tr className="custom-resizable-table-header">
                    <th>
                      <div className="custom-resizable-table-th-content">
                        Products & Technology
                      </div>
                    </th>
                    <th>
                      <div className="custom-resizable-table-th-content">
                        Capabilities
                      </div>
                    </th>
                    <th>
                      <div className="custom-resizable-table-th-content">
                        Specialization
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="gtr-row" style={{ backgroundColor: "#fff" }}>
                    <td className="gtr-cell">
                      {/* <p> */}
                      <CollapsibleCell
                        data={facility.products_and_technologies}
                        render={(s) => formatBoldText(s) || "—"}
                      />
                      {hasTooltipPayload(
                        facility.products_and_technologies
                      ) && (
                        <InfoTooltipIcon
                          payload={facility.products_and_technologies}
                        />
                      )}
                      {/* </p> */}
                    </td>
                    <td className="gtr-cell">
                      {/* <p>
                        {formatBoldText(facility.capabilities?.join(", ")) ||
                          "—"}
                      </p> */}
                      <CollapsibleCell
                        data={facility.capabilities?.join(", ") || "—"}
                        render={(s) => formatBoldText(s) || "—"}
                      />
                      {hasTooltipPayload(facility.capabilities) && (
                        <InfoTooltipIcon payload={facility.capabilities} />
                      )}
                    </td>
                    <td className="gtr-cell">
                      {/* <p>
                        {formatBoldText(facility.specializations?.join(", ")) ||
                          "—"}
                      </p> */}
                      <CollapsibleCell
                        data={facility.specializations?.join(", ") || "—"}
                        render={(s) => formatBoldText(s) || "—"}
                      />
                      {hasTooltipPayload(facility.specializations) && (
                        <InfoTooltipIcon payload={facility.specializations} />
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ManufacturingAndTechnologyInfrastructure;
